import { useMemo } from "react";

export default function Menu() {
  // const showAction = standing_delete === 1 && userType === 1;

  // 🔹 UseMemo to build menu dynamically — easier to maintain
  const menuItems = useMemo(
    () =>
      [
        { key: "exchange", label: "EXCH", className: "menuExchange" },
        { key: "symbol", label: "SYMBOL", className: "menuSymbol" },
        { key: "expiry", label: "EXPIRY", className: "menuExpiry" },
        { key: "buySell", label: "BUY/SELL", className: "menuBuyPrice" },
        { key: "qty", label: "QTY", className: "menuBuyQty" },
        { key: "rate", label: "RATE", className: "menuSellPrice" },
        { key: "liveRate", label: "LIVE RATE", className: "menuSellPrice" },
        { key: "pl", label: "P/L", className: "menuClose" },
        {
          key: "selfPl",
          label: "SELF P/L",
          className: "menuClose",
        },
        { key: "lttLut", label: "LTT/LUT", className: "menuLtt" },
        { key: "date", label: "DATE", className: "menuLtt" },
        {
          key: "dateUpdate",
          label: "UPDATE-DATE",
          className: "menuLtt",
        },
        { key: "sqOff", label: "SQ-OFF", className: "menuBuyQty" },
        // showAction && {
        //   key: "action",
        //   label: "ACTION",
        //   className: "menuBuyQty",
        // },
      ].filter(Boolean), // remove falsy entries
    []
  );

  return (
    <div className="menuContainer primary white">
      <div className="menuIcon" />
      {menuItems.map((item) => (
        <div key={item.key} className={item.className}>
          {item.label}
        </div>
      ))}
    </div>
  );
}
